<template>
    <div ref="timespan" :id="data.ruleID">
        <b-container class="pl-0">
            <b-row no-gutters>

                <b-col v-if="displayMinutes" class="m-1">
                    <b-input-group>
                        <b-form-input ref="minutes" type="number" v-model="minutes" @change="timeChanged" />
                        <b-input-group-append><b-input-group-text>Minutes</b-input-group-text></b-input-group-append>
                    </b-input-group>
                </b-col>

                <b-col v-if="displayHours" class="m-1">
                    <b-input-group>
                        <b-form-input ref="hours" type="number" v-model="hours" @change="timeChanged" />
                        <b-input-group-append><b-input-group-text>Hours</b-input-group-text></b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row no-gutters>

                <b-col v-if="displayDays" class="m-1">
                    <b-input-group>
                        <b-form-input ref="days" type="number" v-model="days" @change="timeChanged" />
                        <b-input-group-append><b-input-group-text>Days</b-input-group-text></b-input-group-append>
                    </b-input-group>
                </b-col>

                <b-col v-if="displayMonths" class="m-1">
                    <b-input-group>
                        <b-form-input ref="months" type="number" v-model="months" @change="timeChanged" />
                        <b-input-group-append><b-input-group-text>Months</b-input-group-text></b-input-group-append>
                    </b-input-group>
                </b-col>

                <b-col v-if="displayYears" class="m-1">
                    <b-input-group>
                        <b-form-input ref="years" type="number" v-model="years" @change="timeChanged" />
                        <b-input-group-append><b-input-group-text>Years</b-input-group-text></b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
        </b-container>

    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';

    Vue.use(BootstrapVue);

    export default {
        name: 'FilterTimespanFieldTemplate',
        data: function () {
            return {
                minutes: 0,
                hours: 0,
                days: 0,
                months: 0,
                years: 0,

                displayMinutes: true,
                displayHours: true,
                displayDays: true,
                displayMonths: true,
                displayYears: true,

            };
        },
        methods: {
            timeChanged: function () {
                var timespan = this.minutes + 'm' + this.hours + 'h' + this.days + 'd' + this.months + "M" + this.years + "y";
                this.data.queryBuilder.$el.ej2_instances[0].notifyChange(timespan, this.$refs.timespan)
            },
            updateDisplay: function () {
                this.displayMinutes = this.data.format.includes("m");
                this.displayHours = this.data.format.includes("h");
                this.displayDays = this.data.format.includes("d");
                this.displayMonths = this.data.format.includes("M");
                this.displayYears = this.data.format.includes("y");
            }

        },
        mounted: function () {
            if (this.data.rule.value != null && this.data.rule.value.length > 0) {
                var minutes = this.data.rule.value.match(/(\d+)m/);
                if (minutes) this.minutes = parseInt(minutes[1]);

                var hours = this.data.rule.value.match(/(\d+)h/);
                if (hours) this.hours = parseInt(hours[1]);

                var days = this.data.rule.value.match(/(\d+)d/);
                if (days) this.days = parseInt(days[1]);

                var months = this.data.rule.value.match(/(\d+)M/);
                if (months) this.months = parseInt(months[1]);

                var years = this.data.rule.value.match(/(\d+)y/);
                if (years) this.years = parseInt(years[1]);
            }
            this.updateDisplay();
        }
    }
</script>